export const mobileDevelopment = [
  {
    title: "React Native Development",
    href: "/services/react-native-development",
  }, 
  {
    title: "Flutter Developmentt",
    href: "/services/flutter-development",
  }, 
  {
    title: "Ionic Development",
    href: "/services/ionic-development",
  }, 
  {
    title: "Phonegap Development",
    href: "/services/phonegap-development",
  }, 
  {
    title: "Hire ReactJS Developers",
    href: "/services/hire-reactjs-developers",
  }, 
];